import { FormControl, FormHelperText } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';

const InputHelperText: React.FC<React.PropsWithChildren<{ error: string }>> = ({
  children,
  error,
}) => (
  <FormControl error={!!error} style={{ width: '100%' }}>
    {children}
    {error && (
      <FormHelperText
        style={{
          textAlign: 'left',
          fontSize: '10.5px',
          margin: '0px 0px 8px 0px',
        }}
      >
        <FormattedMessage id={error} />
      </FormHelperText>
    )}
  </FormControl>
);

export default InputHelperText;
